const reviews = [
    {
      imageUrl: 'https://d5l8cb2ud43ux.cloudfront.net/16774a89-98a6-4512-a740-045244818642_s61i16.webp',
      text: '"שירות מעולה 10מ10. משלוח מהיר, הגיע תוך שלושה ימים. המוצר מהמם. אזמין עוד."',
      iconUrl: '/assets/images/revgoogle.svg',
      reviewer: 'ruty_fogler'
    },
    {
      imageUrl: 'https://d5l8cb2ud43ux.cloudfront.net/2023-07-22_20-10-18_jb4pvz.webp',
      text: '"מהמםםם יצא פשוט מושלם!! הקיר מנציח רגשות וזכרונות בצורה אסתטית ומהממת!"',
      iconUrl: '/assets/images/revinstagram.svg',
      reviewer: '@elinorrahamim'
    },
    {
      imageUrl: 'https://d5l8cb2ud43ux.cloudfront.net/IMG_1055_ojgfor.webp',
      text: '"הקיר יצא יפה מאוד, כיף לי להסתכל על המשפחה שלי והזכרונות שבנינו ביחד"',
      iconUrl: '/assets/images/revgeneral.svg',
      reviewer: 'אלברט כהן'
    },
    {
      imageUrl: 'https://d5l8cb2ud43ux.cloudfront.net/IMG_3163_buefji.webp',
      text: '"ממש ממש פשוט להדביק אותן על הקיר, תלינו בחדר יצא שלמות !!!!! תודה רבה רבה"',
      iconUrl: '/assets/images/revinstagram.svg',
      reviewer: 'h_kadosh'
    },
  ];
  
  export default reviews;
  